<script setup lang="ts">
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import {computed, ref} from "vue";
import {
  fetchPaymentTemplates,
} from "@/components/forms/payout/legacy/payment-templates";
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";
import {useRequest} from "vue-request"
const props = defineProps({
  system: {
    required: true,
    default: null
  },
  document: {
    required: false,
    default: null
  }
})

const emits = defineEmits(['input', 'selected'])


const system = computed(() => props.system);
const hasSystem = computed(() => {
  return system.value && (system.value.length > 0);
})


const templatesData = useRequest(() => fetchPaymentTemplates(system.value), {
  cacheKey: () => 'my-payment-templates-' + system.value,
  ready() {
    return hasSystem.value;
  },
  onAfter() {
    if (props.document) {
      selectTemplateByDocumentId(props.document);
    }
  },
  refreshDeps: [system]
})

const templatable = computed(() => {
  return templatesData.data?.value?.templatable || !templatesData.data?.value
      || !templatesData.loading?.value;
})
const templates = computed(() => {
  return templatesData.data?.value?.templates || [];
})

const loading = computed(() => {
  return hasSystem.value && templatesData.loading?.value;
})

const showBlock = computed(() => {
  return hasSystem.value && (templatable.value || templatesData.loading?.value);
})

const primeDropdownOptions = computed(() => {
  return templates.value || [];
})

const selectedTemplateId = ref(null);

const selectTemplateById = (id) => {
  const tpl = templates.value.find((template) => {
    return +template.id === +id;
  });
  if (tpl) {
    selectedTemplateId.value = +id;
    emits('selected', tpl);
    emits('input', tpl);
  } else {
    selectedTemplateId.value = null;
    emits('selected', null);
    emits('input', null);
  }
}

const selectTemplateByDocumentId = (id) => {
  const tpl = templates.value.find((template) => {
    return +template.documentId === +id;
  });
  // console.log('selectTemplateByDocumentId', tpl);
  if (tpl) {
    selectedTemplateId.value = +tpl.id;
    emits('selected', tpl);
    emits('input', tpl);
  } else {
    selectedTemplateId.value = null;
    emits('selected', null);
    emits('input', null);
  }
}

const clear = () => {
  selectTemplateById(null);
}

defineExpose({
  clear
})
</script>

<template>
  <div v-if="showBlock">
    <template>
      <payout-form-group :label="$t('Выбрать из шаблона')">
<!--        <dropdown-keyvalue :options="dropdownOptions"-->
<!--                           :placeholder="$t('Выберите шаблон')"-->
<!--                           :value="selectedTemplateId"-->
<!--                           @input="selectTemplateById($event)"-->
<!--                           v-if="!loading && templates.length > 0"></dropdown-keyvalue>-->

        <template  v-if="!loading && templates.length > 0">
          <div style="width: 370px">
            <PrimeDropdown :value="selectedTemplateId"
                           @input="selectTemplateById($event)"
                           optionLabel="name"
                           :placeholder="$t('Выберите шаблон')"
                           optionValue="id"
                           :options="primeDropdownOptions"
            ></PrimeDropdown>
          </div>
        </template>

        <div v-if="loading" class="form-control spt--hint-text">
          <span>{{ $t('Идет поиск...') }}</span>
        </div>
        <div v-if="!loading && templates.length == 0" class="form-control spt--hint-text">
          <span>{{ $t('Для этих платежей нет сохраненных шаблонов.') }}</span>
        </div>
      </payout-form-group>
    </template>
  </div>
</template>

<style scoped lang="less">
.spt--hint-text {
  box-shadow: none;
  background: #fff;
  user-select: none;
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 1.2em;
  span {
    line-height: 1.3;
    height: 32px;
    display: flex;
    margin: 0;
    float: none;
    align-items: center;
    justify-content: flex-start;
  }
}
</style>

<i18n>
{
  "en": {
    "Выбрать из шаблона": "Select from template",
    "Идет поиск...": "Searching...",
    "Выберите шаблон": "Select template",
    "Для этого типа платежей нет сохраненных шаблонов.": "There are no saved templates for this type of payments.",
    "Для этих платежей нет сохраненных шаблонов.": "There are no saved templates for this type of payments."
  }
}
</i18n>
